import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getTotalShipments = {
  name: "getTotalShipments" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
